const fonts = {
  fa: {
    thin: "thinFA",
    light: "lightFA",
    default: "regularFA",
    medium: "mediumFA",
    bold: "boldFA",
    extraBold: "extraBoldFA",
    black: "blackFA",
    extraBlack: "extraBlackFA",
  },
  en: {
    thin: "thinEN",
    light: "lightEN",
    default: "regularEN",
    medium: "mediumEN",
    bold: "boldEN",
    extraBold: "extraBoldEN",
    black: "blackEN",
    extraBlack: "extraBlackEN",
  },
};

export default fonts;
